var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamaskFoxTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 183 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M150.457 28.0816C149.658 27.5566 148.777 27.1833 147.943 26.7166C147.403 26.4133 146.827 26.1449 146.357 25.7599C145.559 25.1066 145.723 23.8233 146.557 23.2633C147.755 22.4699 149.74 22.9133 149.952 24.5349C149.952 24.5699 149.987 24.5933 150.022 24.5933H151.831C151.878 24.5933 151.913 24.5583 151.902 24.5116C151.808 23.3916 151.373 22.4583 150.574 21.8633C149.811 21.2916 148.942 20.9883 148.014 20.9883C143.233 20.9883 142.798 26.0166 145.371 27.6033C145.664 27.7899 148.19 29.0499 149.083 29.5983C149.975 30.1466 150.257 31.1499 149.87 31.9433C149.517 32.6666 148.601 33.1683 147.685 33.1099C146.686 33.0516 145.911 32.5149 145.641 31.6749C145.594 31.5233 145.57 31.2316 145.57 31.1033C145.57 31.0683 145.535 31.0333 145.5 31.0333H143.538C143.503 31.0333 143.468 31.0683 143.468 31.1033C143.468 32.5149 143.82 33.2966 144.783 34.0083C145.688 34.6849 146.675 34.965 147.696 34.965C150.375 34.965 151.761 33.4599 152.043 31.8966C152.289 30.3683 151.831 28.9916 150.457 28.0816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M65.2825 21.2441H64.4133H63.4618C63.4266 21.2441 63.4031 21.2675 63.3913 21.2908L61.7821 26.5641C61.7586 26.6341 61.6646 26.6341 61.6411 26.5641L60.0318 21.2908C60.0201 21.2558 59.9966 21.2441 59.9613 21.2441H59.0099H58.1406H56.966C56.9307 21.2441 56.8955 21.2791 56.8955 21.3141V34.7775C56.8955 34.8125 56.9307 34.8475 56.966 34.8475H58.9277C58.9629 34.8475 58.9981 34.8125 58.9981 34.7775V24.5458C58.9981 24.4641 59.1156 24.4525 59.1391 24.5225L60.7601 29.8308L60.8776 30.2041C60.8893 30.2391 60.9128 30.2508 60.948 30.2508H62.4516C62.4868 30.2508 62.5103 30.2275 62.5221 30.2041L62.6395 29.8308L64.2606 24.5225C64.2841 24.4408 64.4015 24.4641 64.4015 24.5458V34.7775C64.4015 34.8125 64.4368 34.8475 64.472 34.8475H66.4337C66.4689 34.8475 66.5042 34.8125 66.5042 34.7775V21.3141C66.5042 21.2791 66.4689 21.2441 66.4337 21.2441H65.2825Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M120.42 21.2441C120.385 21.2441 120.361 21.2675 120.349 21.2908L118.74 26.5641C118.717 26.6341 118.623 26.6341 118.599 26.5641L116.99 21.2908C116.978 21.2558 116.955 21.2441 116.919 21.2441H113.936C113.9 21.2441 113.865 21.2791 113.865 21.3141V34.7775C113.865 34.8125 113.9 34.8475 113.936 34.8475H115.897C115.933 34.8475 115.968 34.8125 115.968 34.7775V24.5458C115.968 24.4641 116.085 24.4525 116.109 24.5225L117.73 29.8308L117.847 30.2041C117.859 30.2391 117.883 30.2508 117.918 30.2508H119.421C119.457 30.2508 119.48 30.2275 119.492 30.2041L119.609 29.8308L121.23 24.5225C121.254 24.4408 121.371 24.4641 121.371 24.5458V34.7775C121.371 34.8125 121.407 34.8475 121.442 34.8475H123.403C123.439 34.8475 123.474 34.8125 123.474 34.7775V21.3141C123.474 21.2791 123.439 21.2441 123.403 21.2441H120.42Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M95.1178 21.2441H91.4646H89.5029H85.8498C85.8145 21.2441 85.7793 21.2791 85.7793 21.3141V22.9941C85.7793 23.0291 85.8145 23.0641 85.8498 23.0641H89.4325V34.7775C89.4325 34.8125 89.4677 34.8475 89.5029 34.8475H91.4646C91.4998 34.8475 91.5351 34.8125 91.5351 34.7775V23.0641H95.1178C95.153 23.0641 95.1882 23.0291 95.1882 22.9941V21.3141C95.1882 21.2791 95.1647 21.2441 95.1178 21.2441Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M106.69 34.8492H108.475C108.522 34.8492 108.557 34.8025 108.546 34.7559L104.857 21.2459C104.845 21.2109 104.822 21.1992 104.787 21.1992H104.105H102.907H102.226C102.191 21.1992 102.167 21.2226 102.156 21.2459L98.4671 34.7559C98.4554 34.8025 98.4906 34.8492 98.5376 34.8492H100.323C100.358 34.8492 100.382 34.8259 100.394 34.8025L101.462 30.8709C101.474 30.8359 101.498 30.8242 101.533 30.8242H105.48C105.515 30.8242 105.538 30.8476 105.55 30.8709L106.619 34.8025C106.631 34.8259 106.666 34.8492 106.69 34.8492ZM102.003 28.8992L103.436 23.6376C103.459 23.5676 103.553 23.5676 103.577 23.6376L105.01 28.8992C105.022 28.9459 104.986 28.9925 104.939 28.9925H102.073C102.026 28.9925 101.991 28.9459 102.003 28.8992Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M137.136 34.8492H138.921C138.968 34.8492 139.004 34.8025 138.992 34.7559L135.304 21.2459C135.292 21.2109 135.268 21.1992 135.233 21.1992H134.552H133.354H132.672C132.637 21.1992 132.614 21.2226 132.602 21.2459L128.913 34.7559C128.902 34.8025 128.937 34.8492 128.984 34.8492H130.769C130.805 34.8492 130.828 34.8259 130.84 34.8025L131.909 30.8709C131.921 30.8359 131.944 30.8242 131.979 30.8242H135.926C135.961 30.8242 135.985 30.8476 135.997 30.8709L137.065 34.8025C137.077 34.8259 137.101 34.8492 137.136 34.8492ZM132.449 28.8992L133.882 23.6376C133.906 23.5676 134 23.5676 134.023 23.6376L135.456 28.8992C135.468 28.9459 135.433 28.9925 135.386 28.9925H132.52C132.473 28.9925 132.437 28.9459 132.449 28.8992Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M74.4688 32.8525V28.6759C74.4688 28.6409 74.5041 28.6059 74.5393 28.6059H79.7665C79.8017 28.6059 79.837 28.5709 79.837 28.5359V26.8559C79.837 26.8209 79.8017 26.7859 79.7665 26.7859H74.5393C74.5041 26.7859 74.4688 26.7509 74.4688 26.7159V23.1459C74.4688 23.1109 74.5041 23.0759 74.5393 23.0759H80.483C80.5183 23.0759 80.5535 23.0409 80.5535 23.0059V21.3259C80.5535 21.2909 80.5183 21.2559 80.483 21.2559H74.4688H72.4367C72.4015 21.2559 72.3662 21.2909 72.3662 21.3259V23.0759V26.7975V28.6175V32.9342V34.7775C72.3662 34.8125 72.4015 34.8475 72.4367 34.8475H74.4688H80.7297C80.765 34.8475 80.8002 34.8125 80.8002 34.7775V33.0042C80.8002 32.9692 80.765 32.9342 80.7297 32.9342H74.5276C74.4923 32.9225 74.4688 32.8992 74.4688 32.8525Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "logo-theme",
    d: "M168.382 34.7308L161.592 27.7659C161.569 27.7425 161.569 27.6959 161.592 27.6725L167.7 21.3725C167.747 21.3259 167.712 21.2559 167.653 21.2559H165.151C165.128 21.2559 165.116 21.2675 165.104 21.2792L159.924 26.6225C159.877 26.6692 159.807 26.6342 159.807 26.5759V21.3259C159.807 21.2909 159.771 21.2559 159.736 21.2559H157.775C157.739 21.2559 157.704 21.2909 157.704 21.3259V34.7892C157.704 34.8242 157.739 34.8592 157.775 34.8592H159.736C159.771 34.8592 159.807 34.8242 159.807 34.7892V28.8625C159.807 28.8042 159.889 28.7692 159.924 28.8159L165.797 34.8358C165.809 34.8475 165.833 34.8592 165.844 34.8592H168.346C168.393 34.8475 168.429 34.7658 168.382 34.7308Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4919 14L31.6162 22.75L33.8245 17.5933L43.4919 14Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1006 14L27.8706 22.8317L25.7679 17.5933L16.1006 14Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2184 34.2891L36.0586 39.0957L42.8246 40.9507L44.7627 34.3941L39.2184 34.2891Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 34.3941L16.7702 40.9507L23.5244 39.0957L20.3763 34.2891L14.8438 34.3941Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1607 26.1675L21.2812 28.9908L27.9767 29.2941L27.7536 22.1191L23.1607 26.1675Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4342 26.1691L31.7709 22.0391L31.6182 29.2957L38.3137 28.9924L36.4342 26.1691Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5244 39.0945L27.577 37.1461L24.0882 34.4395L23.5244 39.0945Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0166 37.1461L36.0574 39.0945L35.5053 34.4395L32.0166 37.1461Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0554 39.0948L32.0146 37.1465L32.3436 39.7598L32.3083 40.8681L36.0554 39.0948Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5225 39.0948L27.2813 40.8681L27.2578 39.7598L27.575 37.1465L23.5225 39.0948Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3526 32.7134L23.9932 31.7334L26.3659 30.6484L27.3526 32.7134Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2393 32.7134L33.226 30.6484L35.6105 31.7334L32.2393 32.7134Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5231 39.0957L24.1104 34.2891L20.375 34.3941L23.5231 39.0957Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4805 34.2891L36.056 39.0957L39.2158 34.3941L35.4805 34.2891Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3117 28.9922L31.6162 29.2955L32.2388 32.7139L33.2255 30.6489L35.61 31.7339L38.3117 28.9922Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9927 31.7339L26.3655 30.6489L27.3522 32.7139L27.9748 29.2955L21.2793 28.9922L23.9927 31.7339Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2793 28.9922L24.0867 34.4405L23.9927 31.7339L21.2793 28.9922Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6106 31.7339L35.5049 34.4405L38.3123 28.9922L35.6106 31.7339Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9741 29.2949L27.3516 32.7133L28.1386 36.7499L28.3148 31.4299L27.9741 29.2949Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.617 29.2949L31.2881 31.4183L31.4525 36.7499L32.2395 32.7133L31.617 29.2949Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2392 32.7124L31.4521 36.7491L32.016 37.1458L35.5047 34.4391L35.6104 31.7324L32.2392 32.7124Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9932 31.7324L24.0871 34.4391L27.5758 37.1458L28.1397 36.7491L27.3526 32.7124L23.9932 31.7324Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3088 40.869L32.3441 39.7607L32.0387 39.504H27.5515L27.2578 39.7607L27.2813 40.869L23.5225 39.0957L24.8381 40.169L27.5045 42.0007H32.0739L34.7521 40.169L36.056 39.0957L32.3088 40.869Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0161 37.1467L31.4523 36.75H28.1398L27.5759 37.1467L27.2588 39.76L27.5525 39.5033H32.0396L32.345 39.76L32.0161 37.1467Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.997 23.3217L44.9955 18.4917L43.4919 14L32.0156 22.4583L36.4323 26.1683L42.6697 27.9767L44.044 26.3783L43.4449 25.9467L44.3964 25.0833L43.6681 24.5233L44.6196 23.8L43.997 23.3217Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5957 18.4917L15.6059 23.3217L14.9598 23.8L15.9231 24.5233L15.1948 25.0833L16.1462 25.9467L15.5472 26.3783L16.9215 27.9767L23.1589 26.1683L27.5756 22.4583L16.0993 14L14.5957 18.4917Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6693 27.9763L36.4319 26.168L38.3113 28.9913L35.5039 34.4396L39.2158 34.393H44.7601L42.6693 27.9763Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1603 26.168L16.9229 27.9763L14.8438 34.393H20.3763L24.0882 34.4396L21.2808 28.9913L23.1603 26.168Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6164 29.2954L32.0157 22.4587L33.8247 17.5938H25.7666L27.5756 22.4587L27.9749 29.2954L28.1276 31.4421L28.1394 36.7504H31.4519L31.4636 31.4421L31.6164 29.2954Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskFoxTitle);
export default __webpack_public_path__ + "static/media/metamask-fox-title.c475aad26a9298f04a655a56ecbb4a62.svg";
export { ForwardRef as ReactComponent };